import React from 'react';

/**
 * Palanca global del formulario: solo ayuda al ingreso de precios.
 * Los montos guardados en BD siguen siendo siempre sin IGV (neto).
 */
const PricesIncludeIgvToggle = ({
  value = false,
  onChange,
  igvRate = 18,
  disabled = false,
  className = '',
}) => {
  const rateLabel = igvRate != null && igvRate !== '' ? `${igvRate}%` : 'IGV';

  return (
    <div
      className={`flex flex-wrap items-center gap-2 sm:gap-3 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg ${className}`}
      title="Los precios se guardan siempre sin IGV. Esta opción solo facilita el ingreso."
    >
      <span className="text-xs sm:text-sm font-medium text-gray-700 whitespace-nowrap">
        Precios ingresados:
      </span>
      <div className="inline-flex rounded-md border border-gray-300 overflow-hidden bg-white shadow-sm">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange(false)}
          className={`px-3 py-1.5 text-xs sm:text-sm font-medium transition-colors ${
            !value
              ? 'bg-teal-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } disabled:opacity-50`}
        >
          Sin IGV
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange(true)}
          className={`px-3 py-1.5 text-xs sm:text-sm font-medium border-l border-gray-300 transition-colors ${
            value
              ? 'bg-teal-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } disabled:opacity-50`}
        >
          Con IGV ({rateLabel})
        </button>
      </div>
    </div>
  );
};

export default PricesIncludeIgvToggle;
